<script lang="ts">
    import {IUIElementTreeNode} from './ui-elements-list.types';
    import UIElementTreeNode from './UIElementTreeNode.svelte';
    import {guiCreatorDataStore} from '../../../stores/guiCreatorData';
    import {GUICreatorData} from '../../../stores/types';


    let pageTrees: { [key: string]: IUIElementTreeNode[] } = {};

    guiCreatorDataStore.subscribe((guiCreatorData: GUICreatorData) => {
        pageTrees = {}
        Object.keys(guiCreatorData.pages).forEach((pageKey) => {
            const page = guiCreatorData.pages[pageKey];
            pageTrees[pageKey] = Object.keys(page.elements).map((elementKey) => {
                const element = page.elements[elementKey];
                return {
                    leaf: true,
                    children: [],
                    value: element.name,
                    uiElement: element,
                    page: pageKey,
                    outsideOfScreen: element.isOutsideOfScreenArea,
                }
            });
            let groupIndexes = {};
            pageTrees[pageKey] = pageTrees[pageKey].reduce((groupedElements, uiElementNode: IUIElementTreeNode) => {
                if (!uiElementNode.uiElement?.group) {
                    groupedElements.push(uiElementNode);
                    return groupedElements;
                }
                const groupName = uiElementNode.uiElement.group;
                if (groupIndexes[groupName] !== undefined) {
                    uiElementNode.parentNode = groupedElements[groupIndexes[groupName]];
                    groupedElements[groupIndexes[groupName]].children.push(uiElementNode);
                } else {
                    groupIndexes[groupName] = groupedElements.length;
                    groupedElements[groupIndexes[groupName]] = {
                        leaf: false,
                        children: [uiElementNode],
                        value: groupName,
                        page: pageKey,
                    }
                    uiElementNode.parentNode = groupedElements[groupIndexes[groupName]];
                }
                return groupedElements;
            }, []);
        });

    });

</script>
<div id="ui-element-tree" style="width: 100%">
    <div class="tree-row border border-info">
        {#each (Object.keys(pageTrees)) as pageTreeKey}
            <div class="page-tree pb-5">
                <div class="border border-b-gray-300">
                    <p class="pb-1 text-lg">Page: <span class="font-bold">{pageTreeKey}</span></p>
                </div>
                {#each (pageTrees[pageTreeKey]) as node}
                    <UIElementTreeNode node="{node}" level="0"></UIElementTreeNode>
                {/each}
            </div>
        {/each}

    </div>

</div>

<style>
    #ui-element-tree {
        float: left;
        overflow-x: auto;
        overflow-y: auto;
    }

    .tree-row {
        width: 100%;
        white-space: nowrap;
    }

</style>
